import React, { useRef } from "react";
import "./addDependanceModal.scss";
import TextInput from "../../textInput/TextInput";
import closeIcon from "../../../images/modal/close-icon.svg";
import YellowButton from "../../buttons/defaultButton/yellowButton/YellowButton";
import useOnClickOutside from "../../../helpers/useOnClickOutside";
import { useState } from "react";
import { useEffect } from "react";
import { useGetPageUnloadQuery } from "../../../redux/services/noLoadingReqAPI";
import useDebounse from "../../../helpers/useDebounse";

const AddDependanceModal = ({ title, isOpen, btnTitle, setIsOpen, onSave, listLink }) => {
    const modalRef = useRef();
    const selectRef = useRef();
    const inputRef = useRef();

    const [isSelectOpen, setIsSelectOpen] = useState(false);
    const [textInputValue, setTextInputValue] = useState("");
    const [parentId, setParentId] = useState(0);

    useOnClickOutside(modalRef, () => setIsOpen(false));
    useOnClickOutside(selectRef || inputRef, () => setIsSelectOpen(false));

    const debounceSearch = useDebounse(textInputValue, 500);
    const { data: selectList } = useGetPageUnloadQuery(listLink + "?per_page=10&search=" + debounceSearch);

    const setValueHandler = (title, id) => {
        setTextInputValue(title);
        setParentId(id);
        setIsSelectOpen(false);
    };

    return (
        <>
            {isOpen && (
                <div className="modal-overlay">
                    <div className="add-dependance-modal" ref={modalRef}>
                        <img
                            src={closeIcon}
                            alt="close"
                            className="add-dependance-modal__close-btn"
                            onClick={() => setIsOpen(false)}
                        />
                        <div className="add-dependance-modal__header">{title}</div>
                        <div className="add-dependance-modal__body">
                            <div className="add-dependance-modal__body-input">
                                <input
                                    placeholder="Заповніть залежність"
                                    type="text"
                                    className="text-input"
                                    value={textInputValue}
                                    onChange={(e) => setTextInputValue(e.target.value)}
                                    onFocus={() => setIsSelectOpen(true)}
                                    onClick={() => setIsSelectOpen(true)}
                                    ref={inputRef}
                                />
                                {isSelectOpen && selectList && (
                                    <div className="add-dependance-modal__body-input-select">
                                        <ul className="add-dependance-modal__body-input-select-list" ref={selectRef}>
                                            {selectList.data.map((listItem) => {
                                                return (
                                                    <li
                                                        className="add-dependance-modal__body-input-select-list-item"
                                                        key={listItem.id}
                                                        onClick={() => setValueHandler(listItem.title, listItem.id)}
                                                    >
                                                        {listItem.title}
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="add-dependance-modal__footer">
                            <YellowButton text={btnTitle} onClick={() => onSave(null, null, parentId)} />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

AddDependanceModal.defaultProps = {
    title: "Modal title",
    isOpen: false,
    onCancel: () => {},
    onSubmit: () => {},
    children: null,
};

export default AddDependanceModal;
